import { formattedDate } from "../../helper";

const ordersData = {
  template_name: "testingheaderimage",
  template_type: "clinical",
  template_header: {
    type: "image",
    upload_progress: 100,
    attachment_id: "615f2f3887ad412daaace5be583fb002",
    file_id: null,
    name: "ic-event.svg",
  },
  template:
    '<div id="header-image"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANcAAAB5CAMAAACdtUQZAAAAZlBMVEX///8AAAD09PTj4+Pw8PD4+Pj7+/vIyMiLi4uwsLDn5+fT09MLCwvf39/s7Ox7e3t0dHRAQECXl5dUVFSjo6MpKSm9vb03NzdpaWmBgYFGRka3t7cxMTFdXV1OTk6dnZ0aGhoiIiIlKgmEAAADr0lEQVR4nO2c2ZKqMBRFCYLMqIBM0t36/z/Z2GobguLA7sq+XNabVT6cXUnOmGAYMzMzMzMzf4il2wA8fu4WQsS6zQATrGpxZKHbEChBKs5MSZfvil8mdMDy5ipL6DYGxlJarCnpWndkfeg2B0VXlvB02wOiuwmFiHQbhMFRZJWmbosgxIqsiWzDpXK4xNbWbRIEdReKnW6LMGwUWRNx8oEi6xDotghDquiahtMwoqYra63bIBDeJEOXsawmKcuwPjuucDJ1lx9KsqppBOQjC8nBf+k2BshVVzqlnsZF12E9kWh84airXnn/rirbirykWrteZHW8g2ma199mnLtp0TRNus6CmN+LWHlSS978y7nlzxd5VXSCWZrk1OEsdjtBqiVMV2qp75S16JMmtIsWrW7Ye9SWRZfViAO1wSHh+lrNv4Od7e+bXGaObVi7RF3OLkWuW0SfWK1CFPZFXYTDfxGEOX6vxH+TmmsvegN78DUKpoTYe2zv04Q8Hj9/fHBe4INFWASV1fp73YJOmGhZJCdsINK+QcjSK82hslKaAYvaxB0ni8VnGDuoLJrbHDZyuTYkHsMAL5ejW80vtjrRGkOmW82VxWNrnyYlKiwzoC6eXWgYtyr6N9no1iKxxMmimsmiqsmWgqkJnOB0rXRrkake2/ssiW4tEnYJkxUyecNHPagX2DMdrwUuOTzQJPItQfPY4CfZ6tYiE2wnqusw6/pPdXH5Ddz5ovLz6o2nEVDF5QjY3GC60uEPj+leotItRsLE5Ydcg687A+W3YDpgwDpFpLrFSCDbNkwvwdSbyKModau5YiN1MYUwXGBuaXhcItJxMN3eADbajtAkHT5WF01XCtiROsEyU4FGsCMVRyHmHNDCSCbnwJT+zJbCewBb9L+Env75ee/JJASCJfv4C10EZwx73+ZESTBq9oGz2AsUUQzvOQqKBNiC6yKZXSK7HD/o9/I/xOCLlSTLBb9ZSfPkaAEtm4k6pFCXSOEMTyxhzwJobmOfwPUDNhz115nelzXehumaVIsJch08LakzmJ3YECS8CpAgRviwbQloTVHk8Srje4lMoyKJsUdsTxSRO4x73saTF/YYNYYgi1wyY8IzQQvqPubbwpKlbtsHubNiYVNlO8fZfZWH20UopYfv0J9EfLq5lEbE3qqXczWE8biH0/1WQ+n03HfkdS+MlURXAYbYbU71WFjU3p0nXZF7fla/L0qC5u6zOFniJlk+2Fjy86zl5gc6ZmZmZmZAfAPeITJERTD+6wAAAABJRU5ErkJggg==" /></div>\n<p>Test 41 Alpha 07/22/2021</p>\n<p>some text in addition to template content</p>',
  practice_id: "114",
  is_active: "1",
  system_generated: false,
  only_show_in_mapped_modules: false,
  created_by: "1191",
  updated_by: "1191",
  updated: "2023-06-23 14:59:48",
  created: "2023-06-23 13:56:07",
  is_signed: 0,
  template_id: "41",
  pid: "3098",
};

const signUnsignOrderData = {
  template_name: "test1",
  template_type: "general",
  template: "",
  practice_id: "114",
  is_active: "1",
  system_generated: false,
  only_show_in_mapped_modules: false,
  created_by: "1191",
  updated_by: "1191",
  updated: "2023-06-26 11:25:21",
  created: "2023-06-26 11:25:21",
  is_signed: 1,
  template_id: "45",
  pid: "3098",
};

export const letterTemplatesCols = [
  // {label: 'Name', key: 'template_name'},
  { label: "Type", widthCss: "min-w-[190px] md:min-w-0 mr-2 flex-1 break-all",  key: "template_type", getVal: (item) => <div className="capitalize">{item?.template_type}</div>,},
  // { label: "Created By", key: "created_by" },
  // {
  //   label: "Created On",
  //   getVal: (item) => formattedDate(item.created, "MM/DD/YYYY hh:mm A"),
  // },
  { label: "Last Modified By", widthCss: "min-w-[190px] md:min-w-0 mr-2 flex-1 break-all", key: "updated_by" },
  {
    label: "Modified On",
    widthCss: "min-w-[190px] md:min-w-0 mr-2 flex-1 break-all",
    getVal: (item) => formattedDate(item.updated, "MM/DD/YYYY hh:mm A"),
  },
  // {
  //   label: "Status",
  //   getVal: (item) =>
  //     item.is_active == 1 || item.is_active == true ? "Active" : "",
  //   widthCss: "flex-none",
  // },
];

export const orderCols = [
  {
    label: "Letter",
    key: "template_name",
    widthCss: "min-w-[190px] mr-2 flex-1 break-all",
  },
  { label: "Type", 
    widthCss: "min-w-[190px] md:min-w-0 mr-2 flex-1 break-all",
    key: "template_type", getVal: (item) => <div className="capitalize">{item?.template_type}</div>,},
  { label: "Created By", 
    widthCss: "min-w-[190px] md:min-w-0 mr-2 flex-1 break-all",
    key: "created_by" },
  {
    label: "Created On",
    widthCss: "min-w-[190px] md:min-w-0 mr-2 flex-1 break-all",
    getVal: (item) => formattedDate(item.created, "MM/DD/YYYY hh:mm A"),
  },

  {
    label: "Status",
    widthCss: "min-w-[190px] md:min-w-0 mr-2 flex-1 break-all",
    getVal: (item) => (item.is_signed == 0 ? "Draft" : "Signed"),
  },
  //   { label: "Actions" },
];
